module.exports = __webpack_public_path__ + "static/media/brooks.29440dda.png";